export const ACTIONS = {
  left: {
    label: '左防',
    shortLabel: '左',
    key: '←',
    hint: '化解左路攻擊',
  },
  center: {
    label: '中攻',
    shortLabel: '拳',
    key: '空白鍵',
    hint: '日字衝拳反擊',
  },
  right: {
    label: '右防',
    shortLabel: '右',
    key: '→',
    hint: '化解右路攻擊',
  },
};

export const ROUND_ONE_SEQUENCE = [
  'left',
  'right',
  'left',
  'center',
  'right',
  'center',
  'left',
  'right',
  'center',
  'center',
];

export const createRoundTwoSequence = () => {
  const actionNames = Object.keys(ACTIONS);
  return Array.from(
    { length: 12 },
    () => actionNames[Math.floor(Math.random() * actionNames.length)],
  );
};

export const THOUSAND_MOVES = [
  { name: '二字鉗羊馬', cue: '穩住馬步', position: 1 },
  { name: '左攤手', cue: '攤手守中', position: 5 },
  { name: '右護手', cue: '護手回中', position: 9 },
  { name: '日字衝拳', cue: '拳走中線', position: 6 },
  { name: '左伏手', cue: '伏手感應', position: 2 },
  { name: '右攤手', cue: '攤手化力', position: 10 },
  { name: '日字衝拳', cue: '肘底發拳', position: 7 },
  { name: '收拳護中', cue: '守中歸位', position: 3 },
  { name: '連環衝拳', cue: '千人齊發', position: 8 },
  { name: '抱拳收式', cue: '同心禮成', position: 4 },
];

export const CARNIVAL_STATIONS = [
  { name: '木人樁體驗', symbol: '樁', detail: '認識角度與中線' },
  { name: '黐手交流', symbol: '黐', detail: '感受來力與變化' },
  { name: '小念頭示範', symbol: '念', detail: '細看詠春基本拳套' },
  { name: '日字衝拳', symbol: '拳', detail: '體驗肘底發力' },
  { name: '詠春文化導賞', symbol: '承', detail: '了解拳術傳承故事' },
  { name: '千人匯演專區', symbol: '千', detail: '投入同心匯演氣氛' },
];

export const SCORE_RANKS = [
  {
    level: '入門',
    title: '小念頭初習',
    minScore: 0,
    range: '0–2,999',
  },
  {
    level: '進階',
    title: '尋橋習者',
    minScore: 3000,
    range: '3,000–5,499',
  },
  {
    level: '熟練',
    title: '黐手能手',
    minScore: 5500,
    range: '5,500–7,999',
  },
  {
    level: '卓越',
    title: '木人樁達人',
    minScore: 8000,
    range: '8,000 或以上',
  },
];

export const getDeviceType = () => {
  const width = window.innerWidth;
  if (width < 768) return 'mobile';
  if (width < 1100) return 'tablet';
  return 'desktop';
};

export const formatNcbDate = (date = new Date()) => {
  return date.toISOString().slice(0, 19).replace('T', ' ');
};

export const getRank = (score) => {
  return [...SCORE_RANKS]
    .reverse()
    .find((rank) => score >= rank.minScore)?.title ?? SCORE_RANKS[0].title;
};